/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";

import routes from "../../routes";
import SideBarBrand from "../brand/SideBarBrand";
import geometricBg from "../../assets/img/geometric-dark.svg";

const Sidebar = (props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
}) => {
  const { open, onClose } = props;

  return (
    <div
      className={`nina-sidebar sm:none duration-200 linear fixed top-0 left-0 !z-50 flex h-[100dvh] w-[290px] flex-col overflow-y-auto overflow-x-hidden border-r border-gray-100 bg-white pb-8 shadow-[8px_0_30px_rgba(112,144,176,0.06)] transition-all dark:border-white/10 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      {/* Formas geométricas abstratas grandes — atrás do conteúdo, só dark */}
      <img
        src={geometricBg}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-[1] hidden h-full w-full object-cover dark:block"
      />

      <button
        type="button"
        aria-label="Fechar menu de navegação"
        className="absolute top-4 right-4 block cursor-pointer rounded-lg p-1 text-gray-500 hover:bg-gray-100 dark:hover:bg-navy-700 xl:hidden"
        onClick={onClose}
      >
        <HiX aria-hidden="true" />
      </button>

      <div className="mx-7 mt-6 flex items-center">
        <SideBarBrand />
      </div>
      <div className="mx-7 mt-4 mb-2 h-px bg-gradient-to-r from-gray-200 to-transparent dark:from-white/10" />

      {/* Nav items */}
      <ul className="mb-auto px-1">
        <Links routes={routes} />
      </ul>

      <div className="dv-sheen mx-5 mt-3 flex items-center gap-2.5 rounded-2xl bg-dv-gradient p-3 text-white shadow-dv-glow">
        <span className="dv-animated-gradient animate-dv-pulse-glow h-7 w-7 shrink-0 rounded-xl bg-[length:200%_200%] ring-2 ring-white/30" />
        <div className="min-w-0">
          <p className="text-[13px] font-bold leading-tight">Portal DataValue</p>
          <p className="mt-0.5 text-[11px] text-white/80">NINA · copiloto de IA</p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
